(function () {
  if (window.__smoothScrollAnchorsInit) return;
  window.__smoothScrollAnchorsInit = true;

  function normalizePath(path) {
    return path.replace(/\/+$/, '') || '/';
  }

  function handleClick(event) {
    var link = event.target.closest('a[href*="#"]');
    if (!link) return;

    var href = link.getAttribute('href');
    if (!href || href === '#') return;

    var url;
    try {
      url = new URL(href, window.location.href);
    } catch (_error) {
      return;
    }

    if (normalizePath(url.pathname) !== normalizePath(window.location.pathname)) return;
    if (!url.hash || url.hash === '#') return;

    var target = document.querySelector(url.hash);
    if (!target) return;

    var behavior = link.dataset.scrollBehavior || 'smooth';
    var block = link.dataset.scrollBlock || 'start';

    event.preventDefault();
    try {
      target.scrollIntoView({ behavior: behavior, block: block });
    } catch (_error) {
      target.scrollIntoView();
    }

    if (history.replaceState) {
      history.replaceState(null, '', url.hash);
    }
  }

  function handleInitialHash() {
    var hash = window.location.hash;
    if (!hash || hash === '#') return;
    var target = document.querySelector(hash);
    if (!target) return;

    requestAnimationFrame(function () {
      try {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (_error) {
        target.scrollIntoView();
      }
    });
  }

  document.addEventListener('click', handleClick);
  window.addEventListener('load', handleInitialHash);
})();
